<template>
  <div v-if="userCS && userCS.id">
    <v-tabs
      v-model="active"
      color="grey"
      dark
      grow
      mandatory
      slider-color="blue"
    >
      <v-tab ripple>
        <v-tooltip bottom>
          <template v-slot:activator="{ onb }">
            <v-btn flat v-on="onb"> Atividades </v-btn>
          </template>
          <span>Atividades do Cliente</span>
        </v-tooltip>
      </v-tab>
      <v-tab-item>
        <Activities />
      </v-tab-item>
      <!-- <v-tab
        ripple
      >
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn flat v-on="on">
                    Observações
                </v-btn>
            </template>
            <span>Observações adicionadas pelos atendentes</span>
        </v-tooltip>
      </v-tab>
      <v-tab-item
      >
        <Observations/>
      </v-tab-item> -->
      <!-- <v-tab
        ripple
      >
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <v-btn flat v-on="on">
                    Tarefas
                </v-btn>
            </template>
            <span>Tickets abertos pelo membro</span>
        </v-tooltip>
      </v-tab>
      <v-tab-item
      >
        <Tasks/>
      </v-tab-item> -->
    </v-tabs>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Activities from "./Activities";
// import Observations from './Observations'
// import Tasks from './Tasks'
export default {
  components: {
    Activities,
    // Observations,
    // Tasks
  },
  computed: {
    ...mapGetters("cs", ["userCS"]),
  },
  created() {
    this.active = 0;
  },
  data() {
    return {
      active: 0,
    };
  },
};
</script>
